import { Check } from "lucide-react";

export function PriceBoard({ name, price, sub, fuelPrice, features = [], badge, featured, testid }) {
  return (
    <div data-testid={testid}
      className={`group relative flex flex-col bg-surface border ${featured ? "border-volt" : "border-white/10"} hover:-translate-y-1 hover:border-volt transition-[transform,border-color] duration-300`}>
      {badge && <div className="absolute -top-3 left-5 bg-volt text-white overline px-3 py-1" data-testid={`${testid}-badge`}>{badge}</div>}
      <div className="flex items-stretch border-b border-white/10">
        <h3 className="flex-1 px-5 py-5 font-head font-extrabold text-xl uppercase tracking-tight self-center">{name}</h3>
        <div className="bg-volt px-5 py-3 flex flex-col justify-center items-end [clip-path:polygon(14px_0,100%_0,100%_100%,0_100%)] pl-8">
          <span className="font-head font-black text-3xl leading-none text-white" data-testid={`${testid}-price`}>{price}</span>
          {sub && <span className="overline text-white/80 mt-1">{sub}</span>}
        </div>
      </div>
      <ul className="p-5 space-y-3 flex-1">
        {features.map((f) => (
          <li key={f} className="flex items-center gap-3 text-sm tracking-wide uppercase">
            <span className="w-5 h-5 border border-volt flex items-center justify-center shrink-0"><Check className="w-3 h-3 text-volt" /></span>
            {f}
          </li>
        ))}
      </ul>
      {fuelPrice && (
        <div className="border-t border-dashed border-white/15 px-5 py-4 flex items-center justify-between" data-testid={`${testid}-fuel-price`}>
          <span className="overline text-muted-foreground">With $5+ fuel</span>
          <span className="font-head font-black text-2xl text-volt">{fuelPrice}</span>
        </div>
      )}
    </div>
  );
}
